import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-excluir',
  templateUrl: './modal-excluir.component.html',
  styleUrl: './modal-excluir.component.scss'
})
export class ModalExcluirComponent {
  @Output() confirmDelete = new EventEmitter<any>();
  @ViewChild('staticDataModal') staticDataModal!: TemplateRef<any>; 
  @Input() payload: any;
  @Input() title: string = '';
  @Input() text: string = '';

  constructor(
    private modalService: NgbModal) { }

  openModal(): void {

    if (this.staticDataModal) {
      this.modalService.open(this.staticDataModal, { centered: true });
    } else {
      console.error('Modal template is not available!');
    }
  }

  confirm(): void {
    // Emitindo o evento para o componente pai
    this.confirmDelete.emit(this.payload);
    this.modalService.dismissAll(); // Fecha o modal
  }
  
}
